import React from "react"
import {Sidenav, Nav} from 'rsuite';
import {useLocation} from "react-router-dom";

const SideNav = () => {
    const location = useLocation();
    const navLinks = [
        {
            path: "/auth",
            name: "Get Your Token"
        },
        {
            path: "/documentation/invoice-submission",
            name: "Invoice Submissions"
        }];
    const navLink = navLinks.map((el, index) => {
        return (
            <Nav.Item key={index}
                className={location.pathname === el.path ? "active-nav" : "inactive-nav"}
                href={el.path}
            >
                {el.name}
            </Nav.Item>
        )
    });

    return (
        <div className="side-nav secondary-color" style={{width: 240}}>
            <Sidenav defaultOpenKeys={['3', '4']}>
                <Sidenav.Body className="side-nav-block">
                    <Nav>
                        {location.pathname !== '/documentation' ? navLink : null}
                    </Nav>
                </Sidenav.Body>
            </Sidenav>
        </div>
    )
}

export default SideNav;
